// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

// import styles bundle
import 'swiper/css/bundle';

/*const swiper = new Swiper(".swiper-container", {
    centeredSlides: true, // 1枚目のスライドを中央にする
    loop: true, // ループさせる
    speed: 1500, // 少しゆっくり(デフォルトは300)
    spaceBetween: 50,
    slidesPerView: "auto", // スライドの表示枚数
    autoplay: { // 自動再生
      delay: 6000, // 3秒後に次のスライド
      disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
    },
  
    });*/

    // const slides = document.querySelectorAll('.swiper-container .swiper-slide');
// const slides_length = slides.length;
const slider = document.getElementById('slider');
//const line = document.getElementById('sliderWaku');

const swiper = new Swiper(".swiper-container", {
  centeredSlides: true, // 1枚目のスライドを中央にする
  loop: true, // ループさせる
  speed: 1500, // 少しゆっくり(デフォルトは300)
  spaceBetween: 0,
  slidesPerView: 1.7, // スライドの表示枚数
  autoplay: { // 自動再生
    delay: 6000, // 3秒後に次のスライド
    disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
  },
	pagination: {
		el: '#slider .swiper-pagination',
		clickable: true,
	},
	breakpoints: {
		768: {
			slidesPerView: 2.5,
			spaceBetween: -90,
			// loopAdditionalSlides: 1,
		},
	},
	on: {
		init: function () {
			let slides = document.getElementsByClassName('swiper-slide');
			// console.log(slides[0]);
			for(var i = 0; i < slides.length; i++) {
				slides[i].classList.add('setPosition');
			}
			// setTimeout(function(){
			// 	$('#campaign-loader').fadeOut(200, 'easeInCirc');
			// },1000);
			setTimeout(function(){
				slider.classList.add('is-shown');
			}, 1000);
		},
		slideChangeTransitionEnd: function () {
			let slides = document.getElementsByClassName('swiper-slide');
			for(var i = 0; i < slides.length; i++) {
				slides[i].classList.add('setPosition');
			}
			//line.classList.add('is-animation');
		},
		slideChangeTransitionStart: function () {
			let slides = document.getElementsByClassName('swiper-slide');
			for(var i = 0; i < slides.length; i++) {
				slides[i].classList.remove('setPosition');
			}
			//line.classList.remove('is-animation');
		},
		resize: function () {
			let slides = document.getElementsByClassName('swiper-slide');
			for(var i = 0; i < slides.length; i++) {
				slides[i].classList.add('setPosition');
			}
			//line.classList.add('is-animation');
		},
	}
  });

  
  
    const insta_swiper = new Swiper(".insta_swiper", {
      centeredSlides: true, // 1枚目のスライドを中央にする
      loop: true, // ループさせる
      speed: 1000, // 少しゆっくり(デフォルトは300)
      spaceBetween: 30,
      slidesPerView: "auto", // スライドの表示枚数
      autoplay: { // 自動再生
        delay: 3000, // 3秒後に次のスライド
        disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
      },
    
      });

	  const shopnews_swiper = new Swiper(".shopnews_slider", {
		pagination: {
		  el: ".shopnews-pagination", //必須の設定：ページネーションのclass指定
		  type: "bullets",
		  clickable: "clickable"
		},
		effect: "fade",
		loop: false, //繰り返し指定
		spaceBetween: 10 //スライド感の余白
	  });

	  /*const renewal_map_swiper = new Swiper(".renewal_map_swiper", {
		// ナビボタンが必要なら追加
		navigation: {
		  nextEl: ".swiper-button-next",
		  prevEl: ".swiper-button-prev"
		}
	  });*/

	  